import { MessageNotification } from "services/types/notifications";

/**
 * Patient text routing: the short "why am I seeing this" line under a MESSAGE
 * notification (bell drawer row, desktop alert, in-app toast). Null for a
 * notification without `routing_reason` — every notification written before
 * the feature — so those render exactly as they always did.
 */
export function getRoutingReasonLine(
  extra: Partial<MessageNotification["extra"]> | null | undefined
): string | null {
  const reason = extra?.routing_reason;
  if (!reason) return null;

  let line: string | null;
  switch (reason) {
    case "assigned":
      line = "Assigned to you";
      break;
    case "following":
      line = extra?.owner_name
        ? `Following · ${extra.owner_name} owns it · you're the inbox owner`
        : "Following · you're the inbox owner";
      break;
    case "reassigned":
      line = "Reassigned to you";
      break;
    case "wants_reschedule":
      line = "Wants to reschedule · assigned to you";
      break;
    default:
      // A reason this build doesn't know yet: say nothing rather than guess.
      line = null;
  }

  if (!line) return null;
  const clinicName = extra?.clinic_name?.trim();
  return clinicName ? `${clinicName} · ${line}` : line;
}

/** The patient a MESSAGE notification is about: `patient_id`, else the older `patient`. */
export function messageNotificationPatientId(
  extra: Partial<MessageNotification["extra"]> | null | undefined
): number | null {
  const id = extra?.patient_id ?? extra?.patient;
  return typeof id === "number" && Number.isFinite(id) ? id : null;
}
